import Immutable from 'immutable';
import {
  CLEAR_FUEL_DAILY_OPERATIONAL_DASHBOARD,
  FLAG_FUEL_DAILY_OPERATIONAL_DASHBOARD_ACTIVITY,
  POST_FUEL_DAILY_OPERATIONAL_DASHBOARD,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_FUEL_DAILY_OPERATIONAL_DASHBOARD_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case POST_FUEL_DAILY_OPERATIONAL_DASHBOARD:
      return state.setIn(['current', 'content'], Immutable.fromJS(payload));
    case CLEAR_FUEL_DAILY_OPERATIONAL_DASHBOARD:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
